/* eslint-disable react/no-unused-state */
/* eslint-disable react/sort-comp */
import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as Notifications from 'fw/globals/Notifications';

class SetupMasterDetail extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = this._initialState(props);
	}

	// API
	reload = () => {
		this._load(this.props.masterId);
		this.reset();
	}

	reset = () => {
		this.setState({
			adding: false,
			selectedId: null,
			enabled: false,
		}, () => {
			this._activeTab && this._activeTab.reset();
		});
	}

	add = () => {
		this._handleAdd();
	}

	// Internal
	_initialState = (props) => {
		return {
			items: [],
			selectedId: null,
			adding: false,
			enabled: false,
			sorting: {
				sortField: props.list.sortField || props.list.columns[0].key,
				sortDirection: props.list.sortDirection,
			},
		};
	}

	_load = (masterId) => {
		// Request
		let rq = this.props.list.loadRequest(masterId);

		rq = {
			...rq,
			sortField: this.state.sorting.sortField,
			sortDirection: this.state.sorting.sortDirection,
		};

		// Post
		new API().post(this.props.list.url, rq,
			{
				success: (r) => {
					this.setState({
						items: r.data.items,
					}, () => {
						// Find and reselect value on grid
						if (this.state.enabled && this.state.selectedId) this._grid.setValue(this.state.selectedId);
					});
				},
			},
			{ block: false });
	}

	// Events
	_triggerSaving = (e) => {
		this.props.onSaving && this.props.onSaving(e);
	}

	_triggerSave = (e) => {
		this.props.onSave && this.props.onSave(e);
	}

	_triggerDirt = (e) => {
		this.props.onDirt && this.props.onDirt(e);
	}

	_triggerUnDirt = (e) => {
		this.props.onUnDirt && this.props.onUnDirt(e);
	}

	// Handlers
	_handleAdd = () => {
		this.setState({
			adding: true,
			selectedId: null,
			enabled: true,
		});
	}

	_handleSaving = () => {
		this._triggerSaving();
	}

	_handleSave = (entityKey) => {
		this.setState({
			selectedId: entityKey,
			adding: false,
			enabled: true,
		}, () => {
			this._load(this.props.masterId);
			this._triggerSave(entityKey);
		});
	}

	_handleDelete = () => {
		this._load(this.props.masterId);
		this._activeTab && this._activeTab.reset && this._activeTab.reset();
	}

	_handleCancel = () => {
		this.reset();
	}

	_handleSuccess = (successData) => {
		Notifications.success(successData);
	}

	_handleError = (error) => {
		this.setState({
			saving: false,
		});

		Notifications.error(error.errorMessage);
	}

	_handleSelect = (selectedId) => {
		this.setState({
			selectedId,
			enabled: true,
			adding: false,
		});

		this.props.onSelect && this.props.onSelect(selectedId);
		this._activeTab && this._activeTab.onSelect && this._activeTab.onSelect(selectedId);

		this._triggerUnDirt();
	}

	_handleSort = (sortField, sortDirection) => {
		this.setState({
			sorting: {
				sortField: sortField,
				sortDirection: sortDirection,
			},
		}, () => {
			this._load(this.props.masterId);
		});
	}

	// React
	componentDidMount() {
		this._load(this.props.masterId);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.masterId !== this.props.masterId) {
			this.setState({
				selectedId: null,
			}, () => {
				this._load(this.props.masterId);
			});
		}
	}

	render() {
		const Detail = this.props.detail;

		const gridChunk = (
			<Grid
				items={this.state.items}
				height={this.props.gridHeight}
				rowKey={this.props.list.rowKey}
				columns={this.props.list.columns}
				sortColumn={this.props.list.sortColumn}
				onChange={this._handleSelect}
				onSort={this._handleSort}
				value={this.state.selectedId}
				ref={(g) => {
					this._grid = g;
				}}
			/>
		);

		const detailChunk = (
			<React.Fragment>
				<Detail
					tabKey="Detail"
					active
					adding={this.state.adding}
					enabled={this.state.enabled}
					helpKey={this.props.helpKey}
					masterId={this.props.masterId}
					showButtons={this.props.showButtons}
					selectedId={this.state.selectedId}
					displayHeaders={false}
					displayIndicators={false}
					reloadOnCancel={false}
					onSaving={this._triggerSaving}
					onDirt={this._triggerDirt}
					onUnDirt={this._triggerUnDirt}
					onSave={this._handleSave}
					onCancel={this._handleCancel}
					onDelete={this._handleDelete}
					onError={this._handleError}
					onSuccess={this._handleSuccess}
					ref={(t) => {
						this._activeTab = t;
					}}
				/>
				<br />
				{' '}
				<br />
			</React.Fragment>
		);

		return (
			<React.Fragment>
				{!this.props.vertical
					&& (
						<React.Fragment>
							{this.props.enableCreate && this.props.addPrivilege
								&& (
									<Button
										id="btnAddNew"
										variant="success"
										className="pull-right"
										bsStyle="success" 
										style={{ marginTop: '-40px' }}
										onClick={this._handleAdd}
									>
										{this.props.addNewTitle}
									</Button>
								)}
							{gridChunk}
							<hr />
							{ this.state.selectedId || this.state.adding ?
								detailChunk
							:null}
						</React.Fragment>
					)}
				{this.props.vertical
					&& (
						<React.Fragment>
							<Row>
								<Col md={this.props.gridCols}>
									{gridChunk}
								</Col>
								<Col md={this.props.detailCols}>
									{this.props.enableCreate && this.props.addPrivilege
										&& (
											<Button
												id="btnAddNew"
												variant="success"
												className="pull-right"
												bsStyle="success" 
												onClick={this._handleAdd}
											>
												{this.props.addNewTitle}
											</Button>
										)}
									{ this.state.selectedId || this.state.adding ?
										detailChunk
									:null}
								</Col>
							</Row>
						</React.Fragment>
					)}
			</React.Fragment>
		);
	}
}

SetupMasterDetail.defaultProps = {
	addNewTitle: 'Create',
	enableCreate: true,
	vertical: false,
	gridCols: 6,
	detailCols: 6,
	gridHeight: 210,
	showButtons: {
        cancel: true,
        save: true,
    },
};

export default SetupMasterDetail;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupMasterDetail.js